<footer class="footer">
  <p>{{ text() }}</p>
</footer>
